import React from 'react';
import glamorous from 'glamorous';
import {WHITE, CHARCOAL} from '../../../shared/style/colors';
import {DESKTOP, PHONE} from '../../../shared/style/breakpoints';
import {BASE_TEXT, FONTS, WEIGHT} from '../../../shared/style/typography';
import {MAX_PAGE_WIDTH} from '../../../shared/style/dimensions';

const Container = glamorous.div(({background = WHITE}) => ({
  display: 'block',
  marginBottom: 120,
  background: background,
  padding: '0 20px',
  [DESKTOP]: {
    padding: 0,
    maxWidth: MAX_PAGE_WIDTH,
    margin: 'auto',
    marginBottom: 120
  },
  [PHONE]: {
    margin: 'auto',
    marginBottom: 124
  }
}));

const Title = glamorous.div({
  ...BASE_TEXT,
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontStyle: 'normal',
  fontWeight: WEIGHT.ULTRA_BLACK,
  fontSize: 40,
  textAlign: 'center',
  lineHeight: '50px',
  color: CHARCOAL,
  marginBottom: 50,
  [PHONE]: {
    fontSize: 28,
    textAlign: 'center',
    margin: 'auto'
  }
});

const IconContainer = glamorous.div({
  textAlign: 'center',
  ' > img': {
    width: 68,
    height: 68,
    marginRight: 30,
    marginLeft: 10
  },
  [PHONE]: {
    marginLeft: 0,
    marginTop: 25,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridRowGap: 38
  }
});

const icons = [
  {
    iconLink: 'https://img.stackshare.io/fe/landing/github_icon.svg'
  },
  {
    iconLink: 'https://img.stackshare.io/fe/landing/azure_icon.svg'
  },
  {
    iconLink: 'https://img.stackshare.io/fe/landing/bitbucket_icon.svg'
  },
  {
    iconLink: 'https://img.stackshare.io/fe/landing/gitlab_icon.svg'
  },
  {
    iconLink: 'https://img.stackshare.io/fe/landing/slack_icon.svg'
  },
  {
    iconLink: 'https://img.stackshare.io/fe/landing/ms-teams_icon.svg'
  }
];

const SupportedIntegrations = () => {
  return (
    <Container>
      <Title>Integrations</Title>
      <IconContainer>
        {icons.map((icon, index) => (
          <img key={index} src={icon.iconLink} />
        ))}
      </IconContainer>
    </Container>
  );
};

export default SupportedIntegrations;
